import React from "react";
import ReactDOM from "react-dom";
import './GlobalDisclaimer.scss'

const GlobalDisclaimer = ( {ui} ) => {
  // console.log("ui in GlobalDisclaimer", ui);
  const disclaimerText = ui.globalDisclaimer;
  // console.log("disclaimerText", disclaimerText);

  
  return ReactDOM.createPortal(
    <div id="disclaimer" >
      {disclaimerText}
    </div>,
    document.getElementById("globaDisclaimer") // DOM node outside root(index.html)
  );
};

export default GlobalDisclaimer;
